<template>
  <div id="app">
    <vue-html2pdf
      :show-layout="controlValue.showLayout"
      :float-layout="controlValue.floatLayout"
      :enable-download="controlValue.enableDownload"
      :preview-modal="controlValue.previewModal"
      :filename="controlValue.filename"
      :paginate-elements-by-height="controlValue.paginateElementsByHeight"
      :pdf-quality="controlValue.pdfQuality"
      :pdf-format="controlValue.pdfFormat"
      :pdf-orientation="controlValue.pdfOrientation"
      :pdf-content-width="controlValue.pdfContentWidth"
      :manual-pagination="controlValue.manualPagination"
      :min-height="controlValue.minHeight"
      :show-Zero="controlValue.showZero"
      :html-to-pdf-options="htmlToPdfOptions"
      :salary-data="salaryData"
      @progress="onProgress($event)"
      @startPagination="startPagination()"
      @hasPaginated="hasPaginated()"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="hasDownloaded($event)"
      ref="html2Pdf"
    >
    <!-- <button @click="salaryData.salary_type = 1">日薪</button>
    <button @click="salaryData.salary_type = 2">項目計算</button>
    <button @click="salaryData.salary_type = 3">項目計算</button> -->

      <template v-if="salaryData.salary_type == 1">
        <!-- 日薪 -->
        <pdf-content-by-daily
          @domRendered="domRendered()"
          :template-options="templateOptions"
          :stamp-options="stampOptions"
          :project-options="projectOptions"
          :remark-options="remarkOptions"
          :bank-options="bankOptions"
          slot="pdf-content"
          :pdf-data="salaryData"
        />
      </template>
      <template v-else-if="salaryData.salary_type == 2">
        <!-- 月薪 -->
        <pdf-content
          @domRendered="domRendered()"
          :template-options="templateOptions"
          :stamp-options="stampOptions"
          :project-options="projectOptions"
          :remark-options="remarkOptions"
          :bank-options="bankOptions"
          slot="pdf-content"
          :pdf-data="salaryData"
        />
      </template>
      <template v-else-if="salaryData.salary_type == 3">
        <!-- 以工程項目計算 -->
        <pdf-content-by-project
          @domRendered="domRendered()"
          :template-options="templateOptions"
          :stamp-options="stampOptions"
          :project-options="projectOptions"
          :remark-options="remarkOptions"
          :bank-options="bankOptions"
          slot="pdf-content"
          :pdf-data="salaryData"
        />
      </template>
      
    </vue-html2pdf>

    <controls-container v-if="salaryData.id && userOptions.length > 0"
      :progress="progress"
      :remark-options="remarkOptions"
      :project-options="projectOptions"
      :user-options="userOptions"
      :salary_record_id.sync="salary_record_id"
      @generateReport="downloadPdf()"
      :salary-data="salaryData"
    />
  </div>
</template>

<script>
import PdfContent from "./PdfContent";
// import VueHtml2pdf from "@/components/VueHtml2pdf";
import ControlsContainer from "./ControlsContainer";
import VueHtml2pdf from "vue-html2pdf";
// import VueHtml2pdf from "vue-html2pdf-test";
import { mapFields } from "vuex-map-fields";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import salaryStoreModule from "../salaryStoreModule";
import { getUserData } from "@/auth/utils";
import PdfContentByDaily from "./PdfContentByDaily";
import PdfContentByProject from "./PdfContentByProject";
// import { useRoute } from 'vue-router';

export default {
  name: "app",
  created() {
    // 獲取薪資記錄選項
    this.$store.dispatch('app/fetchSalaryRecordOptions');
  },

  data() {
    return {
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },
  setup() {
    const route = router.currentRoute;
    const salaryData = ref({template_id: 1, stamp_id: 1,salary_records:[] });

    const INVOICE_STORE_MODULE_NAME = "salary";

    if (!store.hasModule(INVOICE_STORE_MODULE_NAME))
      store.registerModule(INVOICE_STORE_MODULE_NAME, salaryStoreModule);

    // onUnmounted(() => {
    //     if (store.hasModule(INVOICE_STORE_MODULE_NAME))
    //         store.unregisterModule(INVOICE_STORE_MODULE_NAME);
    // });

    const salary_record_id = ref(route.params.id);

    watch(
      [salary_record_id],
      () => {
        refetchData();
      }
    );

    const refetchData = () => {
      // 如果沒有 salary_record_id，則不進行請求
      if (!salary_record_id.value) {
        console.warn('缺少薪資記錄ID (salary_record_id)');
        return;
      }

      // 優先使用簡化的 salary_summary_id 參數
      if (route.query.salary_summary_id) {
        const simplifiedParams = {
          salary_summary_id: route.query.salary_summary_id
        };

        console.log('Fetching salary data with simplified API using salary_summary_id:', simplifiedParams.salary_summary_id);

        store
          .dispatch(INVOICE_STORE_MODULE_NAME + "/fetchSalariesForExportEnhanced", simplifiedParams)
          .then((response) => {
            salaryData.value = {
              template_id: 1,
              stamp_id: 1,
              salary_type: response.data.salary_type,
              ...response.data.user,
              // 為了向後兼容，保留 salary_records 字段
              salary_records: response.data.salary_data
            };

            console.log('Simplified Salary Data:', salaryData.value);
            return; // 成功後直接返回，不執行後續的傳統模式
          })
          .catch((error) => {
            console.warn('Simplified API failed, falling back to traditional mode:', error);
            // 如果簡化模式失敗，繼續執行傳統模式
            // fetchWithTraditionalParams();
          });
      } else {
        // 如果沒有 salary_summary_id，直接使用傳統模式
        // fetchWithTraditionalParams();
      }
    };

    const templateOptions = ref([]);
    const stampOptions = ref([]);
    const projectOptions = ref([]);
    const remarkOptions = ref([]);
    const userOptions = ref([]);
    const bankOptions = ref([]);
    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          templates: true,
          stamps: true,
          projects: true,
          salary_remarks: true,
          users: true,
          banks: true,
        })
        .then((response) => {
          templateOptions.value = response.data.templates;
          stampOptions.value = response.data.stamps;
          projectOptions.value = response.data.projects
          bankOptions.value = response.data.banks;
          if(getUserData().user_type_id == 4){
            projectOptions.value = response.data.projects.filter(
            ele =>
              (ele.users.length > 0 && ele.users.find(user => user.id == router.currentRoute.params.id)) || ele.manager_id == router.currentRoute.params.id
            );
          }else{
            projectOptions.value = response.data.projects
          }
          remarkOptions.value = response.data.salary_remarks;
          userOptions.value = response.data.users;
          refetchData();
        });
    };

    refetchOption();

    return {
      salaryData,
      refetchData,
      templateOptions,
      stampOptions,
      projectOptions,
      remarkOptions,
      userOptions,
      bankOptions,
      salary_record_id
    };
  },

  computed: {
    ...mapFields(["controlValue"]),

    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: this.controlValue.filename,
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: 2,
          quality: 2,
          //logging:true,
          letterRendering: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
          compress: true,
        },
      };
    },
  },

  methods: {
    async downloadPdf() {
      if (!(await this.validateControlValue())) return;

      this.$refs.html2Pdf.generatePdf();
    },

    validateControlValue() {
      if (this.controlValue.pdfQuality > 4) {
        alert("pdf-quality value should only be 0 - 2");
        this.controlValue.pdfQuality = 4;

        return false;
      }

      if (!this.controlValue.paginateElementsByHeight) {
        alert("paginate-elements-by-height value cannot be empty");
        this.controlValue.paginateElementsByHeight = 1400;

        return false;
      }

      const paperSizes = [
        "a0",
        "a1",
        "a2",
        "a3",
        "a4",
        "letter",
        "legal",
        "a5",
        "a6",
        "a7",
        "a8",
        "a9",
        "a10",
      ];

      if (!paperSizes.includes(this.controlValue.pdfFormat)) {
        alert(`pdf-format value should only be ${paperSizes}`);
        this.controlValue.pdfFormat = "a4";

        return false;
      }

      if (!this.controlValue.pdfOrientation) {
        alert("pdf-orientation value cannot be empty");
        this.controlValue.pdfOrientation = "portrait";

        return false;
      }

      if (!this.controlValue.pdfContentWidth) {
        alert("pdf-content-width value cannot be empty");
        this.controlValue.pdfContentWidth = "800px";

        return false;
      }

      return true;
    },

    onProgress(progress) {
      this.progress = progress;
      console.log(`PDF generation progress: ${progress}%`);
    },

    startPagination() {
      console.log(`PDF has started pagination`);
    },

    hasPaginated() {
      console.log(`PDF has been paginated`);
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      console.log(`On Before PDF Generation`);
      // await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
      // 	const totalPages = pdf.internal.getNumberOfPages()
      // 	for (let i = 1; i <= totalPages; i++) {
      // 		pdf.setPage(i)
      // 		pdf.setFontSize(10)
      // 		pdf.setTextColor(150)
      // 		pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
      // 	}
      // }).save()
    },

    hasDownloaded(blobPdf) {
      console.log(`PDF has downloaded yehey`);
      this.pdfDownloaded = true;
      console.log(blobPdf);
    },

    domRendered() {
      this.contentRendered = true;
    },

    onBlobGenerate(blob) {
      console.log(blob);
    },
  },

  components: {
    VueHtml2pdf,
    PdfContent,
    ControlsContainer,
    PdfContentByDaily,
    PdfContentByProject
  },
};
</script>

<style lang="scss" scoped>
</style>
